<template>
  <div class="awards">
    <spotlight-product-list :product-list="productList">
      <template v-slot="slotProps">
        <div v-for="(data, index) in slotProps.product.payload.data" :key="`award-${index}`">
          <award-card
            :award-name="data.awardName"
            :award-reporter="data.awardReporter"
            :award-year="data.awardYear"
            @click.native="trackClick($event, `features.${slotProps.product.name}`)"
          >
          </award-card>
        </div>
      </template>
    </spotlight-product-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AwardCard from '@/modules/spotlight/components/categories/awards/AwardsCard.vue';
import { spotlightMixin } from '@/mixins';
import SpotlightProductList from '@/modules/spotlight/components/SpotlightProductList.vue';
import log from '@/services/log';

export default {
  name: 'Awards',
  mixins: [spotlightMixin],
  components: {
    SpotlightProductList,
    AwardCard,
  },
  computed: {
    ...mapGetters('spotlight', ['getSpotlightCategories']),
    productList() {
      return this.getSpotlightCategories.find(payload => payload.category === 'awards-and-ratings')?.spotlights || [];
    },
  },
  methods: {
    trackClick(e, spotlight) {
      // Analytics tracking
      const payload = {
        elementInteractedWith: `spotlight.${spotlight}.click`,
      };
      this.$store.dispatch('metrics/logModalInteraction', payload).catch(error => {
        log('Error in logging interaction', error);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.awards {
  border-top: 1px solid rgb(218, 226, 234);
  border-spacing: 20px 20px;
}
</style>
